module.exports = __webpack_public_path__ + "static/media/girluplogo.e99d07ee.png";